import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

export default function ParetoChart({ items = [] }) {
  const data = items.map((i) => ({
    subsystem: i.subsystem,
    "Failure Count": i.count,
    "Downtime (Minutes)": Math.round(i.downtime_min),
    "Cumulative %": i.cumulative_percent,
  }));

  return (
    <ResponsiveContainer width="100%" height={280}>
      <ComposedChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
        <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="subsystem" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
        <YAxis yAxisId="left" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
        <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} unit="%" domain={[0, 100]} />
        <Tooltip
          contentStyle={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12 }}
          cursor={{ fill: "#f1f5f9" }}
        />
        <Legend wrapperStyle={{ fontSize: 11 }} iconType="circle" />
        <Bar yAxisId="left" dataKey="Failure Count" fill="#1e40af" radius={[4, 4, 0, 0]} maxBarSize={36} />
        <Bar yAxisId="left" dataKey="Downtime (Minutes)" fill="#93c5fd" radius={[4, 4, 0, 0]} maxBarSize={36} />
        <Line yAxisId="right" type="monotone" dataKey="Cumulative %" stroke="#ef4444" strokeWidth={2.5} dot={{ r: 4, fill: "#ef4444" }} />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
